export const TOOLBAR_BUTTON_CLASS =
  "inline-flex cursor-pointer items-center gap-1.5 rounded-lg border border-border bg-card px-3 py-2 text-sm font-medium text-foreground shadow-sm transition hover:bg-accent/60";

export const DASH = "—";
